import React from 'react';
import { chakra } from '@chakra-ui/react';

type Props = {
  width?: number;
  fill?: string;
};

export const USDCIcon = ({ width = 20, fill = '#677DE3' }: Props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_24736_31688)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.96094 -0.00146484C13.9316 -0.00146484 17.9609 4.02789 17.9609 8.99853C17.9609 13.9688 13.9316 17.9985 8.96094 17.9985C3.99027 17.9985 -0.0390625 13.9688 -0.0390625 8.99853C-0.0390625 4.02789 3.99027 -0.00146484 8.96094 -0.00146484Z"
        fill="#2775CA"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.32505 15.0511C7.32505 15.2589 7.15929 15.3769 6.9546 15.3142C4.23416 14.4622 2.26172 11.9578 2.26172 9.00286C2.26172 6.04797 4.23416 3.54351 6.9546 2.69149C7.15929 2.62916 7.32505 2.74682 7.32505 2.9546V3.46752C7.32505 3.60585 7.21584 3.76866 7.0816 3.81374C4.92923 4.58968 3.38734 6.61964 3.38734 8.99935C3.38734 11.379 4.92923 13.4094 7.0816 14.1849C7.21584 14.2335 7.32505 14.3927 7.32505 14.5316V15.0511Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.56483 13.1409C9.56483 13.2935 9.43782 13.4182 9.28261 13.4182H8.72149C8.56628 13.4182 8.43931 13.2935 8.43931 13.1409V12.2681C7.21132 12.1054 6.61166 11.4298 6.44928 10.5119C6.42097 10.3558 6.54795 10.2139 6.71032 10.2139H7.35253C7.48657 10.2139 7.59955 10.3075 7.62778 10.4389C7.74781 10.9863 8.06886 11.4055 9.05317 11.4055C9.78004 11.4055 10.2954 11.007 10.2954 10.4115C10.2954 9.81545 9.99179 9.5904 8.92619 9.41704C7.35253 9.20925 6.60806 8.74149 6.60806 7.5291C6.60806 6.59387 7.32798 5.8665 8.44288 5.71054V4.85488C8.44288 4.70242 8.56997 4.57764 8.72507 4.57764H9.28621C9.44142 4.57764 9.5684 4.70242 9.5684 4.85488V5.73481C10.4752 5.89442 11.0503 6.39984 11.2375 7.2381C11.2726 7.39771 11.1457 7.54636 10.9799 7.54636H10.387C10.26 7.54636 10.1542 7.46314 10.1154 7.342C9.95662 6.80877 9.5684 6.58022 8.89439 6.58022C8.14995 6.58022 7.7653 6.93345 7.7653 7.42873C7.7653 7.95179 7.98419 8.21489 9.12751 8.37801C10.6727 8.58579 11.4704 9.01873 11.4704 10.3111C11.4704 11.2913 10.7293 12.0846 9.5684 12.2681V13.1409H9.56483Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.0619 15.3131C10.8574 15.3758 10.6914 15.2578 10.6914 15.05V14.5374C10.6914 14.385 10.7867 14.243 10.9348 14.1908C13.0872 13.4149 14.6291 11.3849 14.6291 9.00524C14.6291 6.62553 13.0872 4.59557 10.9348 3.81962C10.8008 3.77104 10.6914 3.61184 10.6914 3.47303V2.96049C10.6914 2.75271 10.8574 2.63154 11.0619 2.697C13.7823 3.5495 15.7547 6.05389 15.7547 9.00875C15.7514 11.9566 13.7823 14.4575 11.0619 15.3131Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_24736_31688">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
